module.exports = __webpack_public_path__ + "static/img/13.3925637.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/13.svg
// module id = 575
// module chunks = 1